export default {
  name: "Addendum C - Material Terms and Conditions of the Job Offer",
  symbol: "list",
  modalPrefill: {
    type: "material-terms",
    machine_name: "eta_790a_addendum_c",
    modal_name: "addProfilesModal",
    title: "Crop/Agricultural Activity Profiles",
    description:
      "Select the Crop/Agricultural Activity profile(s) to populate in the Addendum A table.",
  },
  pageInfo: {
    text: "<b>Important Note</b>: Information disclosed in Addendum C must NOT restate regulatory requirements, assurances, or obligations contained elsewhere on the form (e.g., assurances contained in Section I) or include statements or conditions related to the employer’s work rules, employee handbook, and other similar detailed materials, unless directly related to regulatory requirements of the H-2A program, including Agricultural Recruitment System regulations. <br/><br/> For example, detailed information an employer normally provides to worker post-hire that is not directly related to H-2A program requirements should not be included. Additional material terms and conditions of employment must comply with the requirements of the Immigration and Nationality Act and the Department's applicable regulations. Additional, separate documents are not permitted; all additional material terms and conditions of the job offer must be contained in Addendum C.",
    coloring: "grey",
    read_more: true,
    character_limit: 459,
  },
  sections: [
    {
      code: "Addendum C",
      machine_name: "eta_790a_addendum_c",
      isModal: true,
      openModalHeader: "Add Addendum C",
      modalHeader: "Add Material Terms and Conditions of the Job Offer",
      listType: "table",
      removeFromFieldArray: true,
      validate: ["tableIncomplete"],
      modalFields: [
        {
          machine_name: "section_number",
          label: "Section of Material Term or Condition",
          widget: "select",
          selection: [
            "Job Duties",
            "Pay Deductions",
            "Job Requirements",
            "Meal Provision",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Referral and Hiring Instructions",
          ],
          validate: ["required"],
          tooltip:
            "Select the Form ETA-790A Section name associated with the additional information to be disclosed.",
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term or Condition",
          widget: "text",
          validate: [
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          hideOnTable: true,
          machine_name: "section_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 3500,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Details of Material Term or Condition must contain at least 5 characters",
            },
            {
              maxLength: 3500,
              message:
                "Details of Material Term or Condition cannot contain more than 3500 characters",
            },
          ],
          tooltip:
            "Enter the additional information to be disclosed related to Items 1 and 2 above.",
        },
      ],
    },
  ],
};
